<template>
	<el-dialog title="Pearson丨PTE Academic丨Teacher's feedback" :visible.sync="showTeacherFeedback">
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<span style="font-size: 16px;font-weight: bold;color:#000">Teacher's Feedback</span>
			</div>
			<div v-if="this.teacherFeedback.feedbackText">
				<div v-html="this.teacherFeedback.feedbackText"></div>
			</div>
			<div v-if="this.teacherFeedback.feedbackAudio">
				<audio :src="this.teacherFeedback.feedbackAudio" controls="controls"></audio>
			</div>
		</el-card>
		<el-card class="box-card" v-for="eachAnswer in userAnswers" :key="eachAnswer.questionsId">
			<div slot="header" class="clearfix">
				<span style="font-size: 16px;font-weight: bold;color:#000">Question Info</span>
				<el-button style="float: right; padding: 3px 0" type="text">
					<span color="#47ADE8">{{ eachAnswer.questionsCode }}</span>
					<span color="#47ADE8">#{{ eachAnswer.questionsId }}</span> 
					<span color="#47ADE8" style="font-weight: bold;">{{ eachAnswer.title }}</span>  
				</el-button>
			</div>
			<div v-if="eachAnswer.imagePath">
				<img :src="eachAnswer.imagePath" height="320"/>
			</div>
			<div v-if="eachAnswer.passage&&eachAnswer.questionsCode!='RO'" style="padding:0 20px 0 20px;">
				<p v-html="eachAnswer.passage"></p>
			</div>
			<div v-if="eachAnswer.questionsCode=='RO'" style="padding:0 20px 0 20px;">
				<p v-html="eachAnswer.passage"></p>
			</div>
			<div v-if="eachAnswer.audioPath">
				<audio :src="eachAnswer.audioPath" controls="controls"></audio>
			</div>
			<div> 
				<span style="font-size: 16px;font-weight: bold;color:#000">Your Answer</span>  
			</div>
			<p>
				<div v-if="eachAnswer.questionsCode=='RA'||eachAnswer.questionsCode=='RS'||eachAnswer.questionsCode=='DI'||eachAnswer.questionsCode=='RL'||eachAnswer.questionsCode=='ASQ'" style="padding: 0 20px 0 20px;">
					<audio :src="eachAnswer.userAudio" controls="controls" style="height: 30px;width: 100%;"></audio>
				</div>
				<div v-if="eachAnswer.userText" style="padding: 0 20px 0 20px;">
					<p>{{ eachAnswer.userText }}</p>
				</div>
			</p>
		</el-card>
		<div slot="footer" class="dialog-footer">
		<el-button type="primary" @click="close">Done</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import protal from "@/api/protal";
	export default {
		name: 'showTeacherFeedback',
		props: ['teacherFeedback'],
		data() {
			return {
				userId: '', 
				userAnswers:null,
			}
		},
		computed: {
			showTeacherFeedback() {
				return this.$store.state.showTeacherFeedback;
			}
		},
		mounted() {
			console.log("teacherfeedback")
			console.log(this.teacherFeedback)
			if(this.teacherFeedback){
					let that = this
					let params={
						examId:this.teacherFeedback.examId,
						userId:this.teacherFeedback.userId
					}
					protal.getStudentExamRes(params).then((res)=>{
						if(res.success){
							console.log(res);
							this.userAnswers=res.result.queUserAnswerList;
							this.userAnswers.forEach((element) =>{
							const studentAnswerObj=JSON.parse(element.content)
							if(element.questionsCode=='MCQM'||element.questionsCode=='MCQS'){
								element.userText=element.passage+"<br>"+element.question;
								let allAnswers="";
								let allAnswersObj=JSON.parse(element.answer);
								for(let i=0;i<allAnswersObj.length;i++){
								allAnswers+="<br>"+allAnswersObj[i]['tab']+"："+allAnswersObj[i]['option'];
								}
								element.passage+=allAnswers;
							}
							if(element.questionsCode=='FIB-RW'){
								let allAnswers="<div class='row'>";
								let allAnswersObj=JSON.parse(element.answer);
								let stuanswer=JSON.parse(element.content);
								element.userText=stuanswer.options.join(",");
								console.log(allAnswersObj);
								for(let i=0;i<allAnswersObj.length;i++){
								let eachOptions=allAnswersObj[i]["options"];
								allAnswers+="<div class='col-md-3'>"+(i+1)+".";
								for(let j=0;j<eachOptions.length;j++){
									let eachAllAnsObj=eachOptions[j];
									allAnswers+="<br>"+eachAllAnsObj['tab']+"："+eachAllAnsObj['option']+(eachAllAnsObj['trueAnswer']?"&#10004;":"");
								}
								allAnswers+="</div>";
								}
								element.passage+=allAnswers+"</div>";
							}
							if(studentAnswerObj.audioUrl){
								element.userAudio=studentAnswerObj.audioUrl;
							}
							if(studentAnswerObj.text){
								element.userText=studentAnswerObj.text;
							}
							if(studentAnswerObj.drags){
								element.userText=studentAnswerObj.drags.join(",");
							}
							if(studentAnswerObj.orderOptions){
								element.userText=studentAnswerObj.orderOptions.join(",");
							}
							if(studentAnswerObj.words){
								element.userText=studentAnswerObj.words.join(",");
							}
							if(studentAnswerObj.answerOptions){
								element.userText=studentAnswerObj.answerOptions.join(",");
							}
							if(element.questionsCode=='RO')
							{
								element.passage=JSON.parse(element.passage);
							}
							});
						}
					}).finally(() => {
					})
				}
			
		},
		methods: {
			back() {
				if(!this.$router){
					this.$router.push({ path: '/package_test' })
					return;
				}
				const routePath = this.$router;
				this.close()
				if(routePath.fullPath != '/package_test'){
					this.$router.push({ path: '/package_test' })
				}
				console.log(routePath)
			},
			close() {
				this.$store.commit("showTeacherFeedbackInfo", false);
			},
		},
	}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/components/showTeacherFeedback.vue